var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M128.704 72.1406C126.313 69.3493 122.103 69.0231 119.311 71.4146L90.667 99.9925L62.0891 71.4146C59.491 68.8299 55.2945 68.8299 52.6963 71.4146C50.1116 74.0127 50.1116 78.2093 52.6963 80.8074L86.0039 114.115C88.602 116.7 92.7985 116.7 95.3967 114.115L128.704 80.8074C130.843 78.3158 130.843 74.6319 128.704 72.1406Z","fill":"black","stroke":"black","strokeWidth":"4"}));
}

DownArrow.defaultProps = {"width":"181","height":"181","viewBox":"0 0 181 181","fill":"none"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
